import { useCallback } from "react"

import { useNavigate } from "react-router-dom"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useUrlParams } from "@l2r-front/l2r-utils"

import {
    TechniqueItemCard,
} from "../../components/TechniqueItemCard"
import { STATUS_DONE } from "../../constants/status"
import {
    useRoadworksDispatchContext,
    useRoadworksStateContext,
} from "../../contexts/RoadworksContext"

export function RoadworkCard(props) {

    const {
        currency,
        index,
        roadwork,
    } = props

    const { selectedRoadwork } = useRoadworksStateContext()
    const { setSelectedRoadwork } = useRoadworksDispatchContext()
    const { deleteParams } = useUrlParams()
    const navigate = useNavigate()

    const clickOnRoadwork = useCallback(() => {
        const unselectRoadwork = roadwork?.uuid === selectedRoadwork
        setSelectedRoadwork(unselectRoadwork ? null : roadwork.uuid)
    }, [roadwork?.uuid, selectedRoadwork, setSelectedRoadwork])

    const goToRoadworkDetails = () => {
        setSelectedRoadwork(roadwork?.uuid)
        deleteParams()
        navigate(`./${roadwork.uuid}`)
    }

    const isSelected = selectedRoadwork === roadwork.uuid
    const isDisabled = roadwork.status === STATUS_DONE
    const doneAt = roadwork.doneAt ? roadwork.doneAt : null

    const technique = {
        ...roadwork.technique,
        year: roadwork.year,
        linearLocation: roadwork.linearLocation,
        uuid: roadwork.uuid,
    }

    return <TechniqueItemCard
        currency={currency?.symbol}
        doneAt={doneAt}
        handleClick={clickOnRoadwork}
        handleGoToDetails={goToRoadworkDetails}
        id={`task-card-${index}${isSelected ? "-selected" : ""}`}
        isDisabled={isDisabled}
        isSelected={isSelected}
        technique={technique}
        status={roadwork.status}
    />
}

RoadworkCard.propTypes = {
    currency: PropTypes.object,
    index: PropTypes.number.isRequired,
    roadwork: PropTypes.roadwork.isRequired,
}